import { useMediaQuery, useTheme } from '@mui/material';

/** True only below `sm` (600px). Dialogs are not full-screen at `sm` or above (TMMAPP-0089). */
export function useDialogFullScreen(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}
